import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const machineApi = {
  async createMachine(data) {
    const response = await api.post('/machines', data);
    return response.data;
  },

  async listMachines() {
    const response = await api.get('/machines');
    return response.data;
  },

  async getMachine(machineId) {
    const response = await api.get(`/machines/${machineId}`);
    return response.data;
  },

  async updateMachine(machineId, data) {
    const payload = typeof data === 'string'
      ? { dsl_source: data }
      : { ir_json: data };
    const response = await api.put(`/machines/${machineId}`, payload);
    return response.data;
  },

  async deleteMachine(machineId) {
    const response = await api.delete(`/machines/${machineId}`);
    return response.data;
  },

  async getCFSP1Scores() {
    const response = await api.get('/machines/cfsp1/scores');
    return response.data;
  },

  async validateMachine(machineId, profile) {
    const response = await api.post(`/machines/${machineId}/validate`, {
      machine_id: machineId,
      profile,
    });
    return response.data;
  },

  async compileMachine(machineId, target) {
    const response = await api.post(`/machines/${machineId}/compile`, {
      machine_id: machineId,
      target,
    });
    return response.data;
  },

  async simulateMachine(machineId, eventName, payload) {
    const response = await api.post(`/machines/${machineId}/simulate`, {
      machine_id: machineId,
      event_name: eventName,
      payload,
    });
    return response.data;
  },

  async getCapabilities() {
    const response = await api.get('/capabilities');
    return response.data;
  },

  async getDemoWorkflow() {
    const response = await api.get('/machines/demo/workflow-orchestrator');
    return response.data;
  },

  async getAuthMachine() {
    const response = await api.get('/auth/machine');
    return response.data;
  },
};
